import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Typography, Box, Alert, CircularProgress, Button } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useDispatch } from 'react-redux';

import StoreFormContainer from '../../features/store-market/StoreFormContainer';
import { StoreFormData } from '../../features/store-market/types/store.types';
import { storeService } from '../../features/store-market/services/storeService';
// import { showNotification } from '../../store/slices/notificationSlice';

const EditStorePage: React.FC = () => {
  const { storeId } = useParams<{ storeId: string }>();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [initialData, setInitialData] = useState<Partial<StoreFormData>>({});

  useEffect(() => {
    const loadStoreData = async () => {
      try {
        if (storeId) {
          const response = await storeService.getStoreById(storeId);
          setInitialData(response.data);
        }
      } catch (error: any) {
        console.error('Erro ao carregar dados da loja:', error);
        alert(error.message || 'Erro ao carregar dados da loja');
      } finally {
        setLoading(false);
      }
    };

    loadStoreData();
  }, [storeId, dispatch]);

  const handleUpdate = async (storeData: StoreFormData) => {
    try {
      if (storeId) {
        await storeService.updateStore(storeId, storeData);
        
        alert('Loja atualizada com sucesso!');
        
        // Redirecionar para o dashboard da loja
        navigate(`/dashboard/lojas/${storeId}/dashboard`);
      }
    } catch (error: any) {
      console.error('Erro ao atualizar loja:', error);
      
      alert(error.message || 'Erro ao atualizar loja');
    }
  };

  const handleSaveDraft = async (storeData: StoreFormData) => {
    try {
      if (storeId) {
        await storeService.updateStore(storeId, { ...storeData, status: 'draft' });
        
        alert('Rascunho salvo com sucesso!');
      }
    } catch (error: any) {
      console.error('Erro ao salvar rascunho:', error);
      
      alert(error.message || 'Erro ao salvar rascunho');
    }
  };

  const handleBack = () => {
    navigate('/dashboard/lojas');
  };

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4, mb: 8 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '400px',
          }}
        >
          <CircularProgress size={60} sx={{ mb: 3 }} />
          <Typography variant="h6" color="text.secondary">
            Carregando dados da loja...
          </Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 2, mb: 4 }}>
      {/* Header da página */}
      <Box sx={{ mb: 4 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
          sx={{ mb: 2 }}
        >
          Voltar para Lojas
        </Button>
        
        <Typography variant="h4" component="h1" gutterBottom color="primary">
          Editar Loja
        </Typography>
        <Typography variant="h6" color="text.secondary">
          Faça as alterações necessárias na sua loja
        </Typography>
      </Box>

      {/* Formulário principal */}
      <StoreFormContainer
        initialData={initialData}
        onSubmit={handleUpdate}
        onSaveDraft={handleSaveDraft}
      />
    </Container>
  );
};

export default EditStorePage;
